import React from 'react';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {useTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';

import {styles} from './NewHAR.style';

interface NewHARItem {
  newRank?: {
    description?: string;
  };
}

interface NewHARProps {
  item?: NewHARItem;
}

export const NewHAR: React.FC<NewHARProps> = ({item = {}}) => {
  const newHAR = get(item, 'newRank.description', '');
  const {tt} = useTranslation('report.record');
  return tt(
    'newHarRank',
    generateComponentCallback({
      component: (
        <Text>
          <Text style={styles.newRankLabel}>New HRA</Text> {newHAR}
        </Text>
      ),
    }),
  );
};

export default NewHAR;
